import { createContext } from 'react';
const MenuContext = createContext({
    prefixCls: '',
    inlineCollapsed: false,
    firstLevel: true,
    notFirstSub: false,
    menuMode: '',
    scope: ''
});
export default MenuContext;
